import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=759e96a9&scoped=true&lang=pug"
import script from "./SimpleHeader.vue?vue&type=script&lang=ts"
export * from "./SimpleHeader.vue?vue&type=script&lang=ts"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&id=759e96a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759e96a9",
  null
  
)

export default component.exports